import { getSalesAddins } from './getSalesAddins';
import type { MailboxInfo } from 'owa-client-types';

export function isSalesCopilotAddin(addinTitleId: string, mailboxInfo: MailboxInfo): boolean {
    return getSalesAddins(mailboxInfo).some(addinIds => addinTitleId === addinIds.titleId);
}
